const MedConnectCalendar = () => {
    return (
      <iframe
        src="https://calendar.google.com/calendar/embed?src=c_ec2385580200ac11a9dd7ca7416a42fbc55895cf58c916046367efcd35fab7ef%40group.calendar.google.com&ctz=America%2FNew_York"
        width="800"
        height="600"
        frameBorder="0"
        scrolling="no"
        title="MedConnect RSO Calendar"
      ></iframe>
    );
  };
  
  export default MedConnectCalendar;